import styled from "styled-components";
import { breakpoints } from "styles/grid";

export const StyledActionsContainer = styled.div`
	display: flex;
	gap: 0.5rem;

	@media (max-width: ${breakpoints.phone - 1}px) {
		width: 100%;
		flex-direction: column;
		gap: 0;

		padding: 0 1rem;
		margin-bottom: 0.75rem;

		button {
			width: 100%;
			padding: 0.5rem 1rem;
			margin-top: 0.75rem;
		}
	}
`;
